var exports = {
  "F": "autosizeTextInputContainer__wiitO0",
};

module.exports = exports;
